<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Registravimas automatu</h3>

    <v-row>
      <v-col cols="12">
        <v-tabs slider-color="primary" v-model="teikimasTab">
          <v-tab
            class="registravimas-tab"
            v-for="item in teikimasList"
            :key="item.value"
          >
            <h4>{{ item.label }}</h4>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <template v-if="isTeikimas">
      <admin-registravimas-automatu-search
        class="mt-1 mb-1"
        :loading="loading"
        :ntrpaslaugos="autNtrPaslaugos"
        @search="searchRegistravimas"
      />

      <v-data-table
        :headers="filteredHeaders"
        :items="itemsList"
        :loading="loading"
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :hide-default-footer="hideFooter"
        :page.sync="page"
        :items-per-page="pageSize"
      >
        <template #top>
          <v-toolbar flat>
            <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label=""
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
        <template #[`item.aut_automatinis_title`]="{ item }">
          <el-busena
            :busena="item.aut_automatinis_title"
            :color="item.aut_automatinis_color"
          />
        </template>
        <template #[`item.aut_automatinis`]="{ item }">
          <el-switch
            v-model="item.aut_automatinis"
            @click.native="changeRegistravimas(item)"
          />
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </template>

    <modal-confirm
      title="Registravimas automatu"
      :text="confirmText"
      :item="confirmItem"
      action="Keitimas"
      v-model="showConfirm"
      @confirmKeitimas="saveData"
      @cancelConfirm="cancelData"
    />
  </v-container>
</template>

<script>
import AdminRegistravimasAutomatuSearch from './AdminRegistravimasAutomatuSearch'
import ModalConfirm from '../modals/ModalConfirm'

export default {
  name: 'AdminRegistravimasAutomatu',
  components: {
    ModalConfirm,
    AdminRegistravimasAutomatuSearch,
  },
  data() {
    return {
      teikimasTab: null,
      teikimasList: [
        {
          label: 'Duomenų teikimas aplikacijoje',
          value: 1,
        },
        {
          label: 'Duomenų teikimas per RC savitarną',
          value: 2,
        },
        {
          label: 'NEP duomenų teikimas aplikacijoje',
          value: 3,
        },
        {
          label: 'NEP duomenų teikimas per RC savitarną',
          value: 4,
        },
      ],
      searchData: {},
      showConfirm: false,
      confirmText: null,
      confirmItem: null,
      pageloading: true,
      loading: true,
      formData: [],
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      page: 1,
    }
  },
  watch: {
    teikimas(val) {
      if (val && !this.pageloading) {
        this.getData()
      }
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Eil. Nr.',
          align: 'start',
          sortable: true,
          value: 'numeris',
        },
        {
          text: 'Registro objektas',
          align: 'start',
          sortable: true,
          value: 'aut_tipas_title',
        },
        {
          text: 'Veiksmas',
          align: 'start',
          sortable: true,
          value: 'aut_veiksmas_title',
        },
        {
          text: 'Registravimas',
          align: 'start',
          sortable: true,
          value: 'aut_automatinis_title',
        },
        {
          text: 'Pakeitimo data',
          align: 'start',
          sortable: true,
          value: 'aut_atnaujinimo_data',
        },
        {
          text: 'Pakeitimą atlikęs asmuo',
          align: 'start',
          sortable: true,
          value: 'busena_pakeite',
        },
        {
          text: 'Įjungti automatinį įregistravimą',
          align: 'center',
          value: 'aut_automatinis',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.formData.map((item, index) => {
        if (item.aut_automatinis) {
          item.aut_automatinis_title = 'automatinis'
          item.aut_automatinis_color = 'green'
        } else {
          item.aut_automatinis_title = 'rankinis'
          item.aut_automatinis_color = 'default'
        }

        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    teikimas() {
      if (this.teikimasTab === null) {
        return null
      }
      return this.teikimasList[this.teikimasTab].value
    },
    isTeikimas() {
      return this.teikimas
    },
    autSavitarna() {
      return this.teikimas === 2 || this.teikimas === 4
    },
    autNtrPaslaugos() {
      return this.teikimas === 3 || this.teikimas === 4
    },
  },
  created() {
    // this.getData()
  },
  methods: {
    searchRegistravimas(searchData) {
      this.searchData = searchData
      this.getData()
    },
    getData() {
      this.pageloading = true
      this.loading = true

      const data = {
        aut_savitarna: this.autSavitarna,
        ntrpaslaugos: this.autNtrPaslaugos,
        search: this.searchData,
      }

      this.$axios
        .post(`admin/iregistravimas`, data)
        .then(res => {
          this.formData = res.data.iregistravimai
          this.page = 1
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(item) {
      this.loading = true

      let data = {
        aut_id: item.aut_id,
        aut_automatinis: item.aut_automatinis,
      }

      this.$axios
        .post(`admin/iregistravimas/${item.aut_id}`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeRegistravimas(item) {
      this.confirmText = `Ar norite ${
        item.aut_automatinis ? 'įjungti' : 'išjungti'
      } veiksmo <b>${item.aut_tipas_title}. ${
        item.aut_veiksmas_title
      }</b> automatinį registravimą?`
      this.confirmItem = item
      this.showConfirm = true
    },
    cancelData(item) {
      item.aut_automatinis = !item.aut_automatinis
      this.showConfirm = false
    },
  },
}
</script>
<style lang="scss" scoped>
.registravimas-tab {
  max-width: 250px;

  h4 {
    font-size: 14px;
  }
}
</style>
